import React from 'react'
import { CircleArrowIcon } from '../../../assets/icons'
import { Text } from 'react-native-paper'
import { TouchableOpacity, View } from 'react-native'
import { commonColors } from '@linqpal/common-frontend/src/theme/colors'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'

type ListItemProps = {
  id?: number
  onPress?: () => void
  icon?: any
  title: any
  subtitle?: any
  endIcon?: any
  style?: object
  disabled?: boolean
  smallTitle?: any
  otherStyles?: {
    iconsAndText?: any
    smallTitle?: any
    title?: any
    subTitle?: any
    endIcon?: any
    frontIcon?: any
    container?: any
  }
  testID?: string
  badge?: React.ReactElement
}

export const ListItem = ({
  id = 0,
  onPress,
  icon,
  title,
  subtitle,
  endIcon,
  style,
  disabled,
  smallTitle,
  otherStyles,
  testID,
  badge,
}: ListItemProps) => {
  return (
    <View
      style={composeStyle(
        { position: 'relative', paddingHorizontal: 9, width: '100%' },
        otherStyles?.container,
      )}
      pointerEvents={onPress ? 'auto' : 'none'}
    >
      {badge}
      <TouchableOpacity
        disabled={disabled}
        key={id}
        style={composeStyle(
          {
            opacity: disabled ? 0.3 : 1,
            minHeight: 72,
            paddingHorizontal: 20,
            width: '100%',
            maxWidth: 700,
            borderWidth: 1,
            borderColor: '#E6EBEE',
            borderRadius: 12,
            marginBottom: badge ? 14 : 19,
            alignSelf: 'center',
            overflow: 'hidden',
            marginTop: badge ? 10 : 0,
          },
          style,
        )}
        onPress={() => {
          if (!disabled) {
            onPress && onPress()
          }
        }}
        testID={testID}
      >
        <View
          style={composeStyle(
            { flexDirection: 'row', height: '100%' },
            otherStyles?.iconsAndText,
          )}
        >
          {icon && (
            <View
              style={composeStyle(
                {
                  marginRight: 15,
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginVertical: 16,
                },
                otherStyles?.frontIcon,
              )}
            >
              {icon}
            </View>
          )}
          <View style={{ flex: 1, justifyContent: 'center' }}>
            {smallTitle && (
              <Text
                style={composeStyle(
                  {
                    fontWeight: '500',
                    fontSize: 12,
                    color: commonColors.textLight,
                    marginBottom: 3,
                  },
                  otherStyles?.smallTitle,
                )}
              >
                {smallTitle}
              </Text>
            )}
            <Text
              style={composeStyle(
                {
                  fontWeight: '500',
                  fontSize: 16,
                  lineHeight: 25,
                  color: commonColors.textDark,
                },
                otherStyles?.title,
              )}
            >
              {title}
            </Text>
            <Text
              style={composeStyle(
                {
                  fontWeight: '500',
                  fontSize: 12,
                  lineHeight: 20,
                  color: commonColors.textLight,
                },
                otherStyles?.subTitle,
              )}
            >
              {subtitle}
            </Text>
          </View>
          {onPress && (
            <View
              style={composeStyle(
                { justifyContent: 'center' },
                otherStyles?.endIcon,
              )}
            >
              {endIcon || <CircleArrowIcon />}
            </View>
          )}
        </View>
      </TouchableOpacity>
    </View>
  )
}
